import React from 'react';
import AnSchedulingInWidgetStep3 from '../anonymousPageNew/components/anSchedulingInWidgetStep3';
import './schedulingInWidgetStep3.css';

const SchedulingInWidgetStep3 = (props) => {
  const onReschedule = () => {
    if (props.recreateBookingOption) props.recreateBookingOption();
    props.moveSchedulingStep(0, false);
    props.restartSchedulingFlow();
  };
  return (
    <>
      <AnSchedulingInWidgetStep3
        {...props}
        isAutoApprovalOn={
          props.mentor?.mentorDto?.scheduleSettingsDto?.autoMentorApproval ??
          props.isAutoApprovalOn
        }
        extendedMentorDto={props.mentor}
        onReschedule={onReschedule}
      />
    </>
  );
};

export default SchedulingInWidgetStep3;
